export enum CfdiStatus {
  Pending,
  Issued,
  Invalid,
}
